import React from 'react';
import './App.css';
import Authentication from './components/authentication/Authentication';

function App() {
  return <Authentication />;
}

export default App;
